import React from 'react';
import { TextInput, TextArea, CardList, SectionHeader } from './Fields';

const COLORS = ['blue', 'emerald', 'violet', 'orange', 'red', 'yellow'];

const DesafiosEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Desafios" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />
      <TextArea label="Subtítulo" value={data.subheading} onChange={v => set('subheading', v)} />

      <CardList
        label="Cards de desafios"
        value={data.items}
        onChange={v => set('items', v)}
        emptyCard={{ title: '', description: '', color: 'blue' }}
        renderCard={(item, i, update) => (
          <div className="space-y-2">
            <TextInput label="Título" value={item.title} onChange={v => update({ title: v })} />
            <TextArea label="Descrição" value={item.description} onChange={v => update({ description: v })} rows={2} />
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Cor</label>
              <div className="flex gap-2 flex-wrap">
                {COLORS.map(c => (
                  <button
                    key={c}
                    onClick={() => update({ color: c })}
                    className={`px-3 py-1 rounded-full text-xs font-semibold border-2 transition-all ${
                      item.color === c ? 'border-blue-500 scale-110' : 'border-transparent opacity-60'
                    } bg-${c}-100 text-${c}-700`}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default DesafiosEditor;
